import { useState, type KeyboardEvent } from 'react';
import { IconButton, Stack, TextField, Tooltip } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import StopIcon from '@mui/icons-material/Stop';

interface AIChatInputProps {
  disabled: boolean;
  sending: boolean;
  onSend: (content: string) => void;
  onStop: () => void;
}

export function AIChatInput({ disabled, sending, onSend, onStop }: AIChatInputProps) {
  const [value, setValue] = useState('');

  const handleSend = () => {
    const trimmed = value.trim();
    if (!trimmed || sending || disabled) return;
    onSend(trimmed);
    setValue('');
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems="flex-end" sx={{ p: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
      <TextField
        fullWidth
        multiline
        maxRows={6}
        size="small"
        placeholder="Ask the assistant…"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
      />
      {sending ? (
        <Tooltip title="Stop">
          <IconButton color="error" onClick={onStop}>
            <StopIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Send">
          <span>
            <IconButton color="primary" onClick={handleSend} disabled={disabled || !value.trim()}>
              <SendIcon />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Stack>
  );
}
